import IApiResponse from "../../interfaces/IApiResponse";
import DexieDB from '../../data/DexieDB'
import SuccessApiResponse from "../../data/SuccessApiResponse";
import IPrayerSettings from "../../interfaces/IPrayerSettings";
import { IPrayerSettingsService } from "../PrayerSettingsService";

const PrayerSettingsServiceWeb: IPrayerSettingsService = {
    
    createPrayerSettings: (prayerSettings) => {
        const dbResponse: Promise<IApiResponse<IPrayerSettings>> = DexieDB.transaction('rw', DexieDB.prayerSettings, async()  => {
            return DexieDB.prayerSettings.add(prayerSettings).then((prayerId)=>{
                prayerSettings.id = prayerId;
                const response = {...SuccessApiResponse, Data: prayerSettings};
                response.Message.UserMessage = 'SUCCESS: ADDED NEW PRAYER.';
                return response;
            });
        }).catch((error)=>{
            const response = {
                Data: prayerSettings,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IPrayerSettings>;
        });

        return dbResponse;
    },
    getPrayerSettings: () =>  {
        const dbResponse: Promise<IApiResponse<IPrayerSettings>> = DexieDB.transaction('r', DexieDB.prayerSettings, async()  => {
            return DexieDB.prayerSettings.get(0).then((result)=>{
                if(result) {
                    return  {...SuccessApiResponse, Data: result};
                } else {
                    return {
                        Data: undefined,
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND PRAYER SETTINGS', ServerMessage: 'FAILED TO GET' }
                    }
                }
            });
        }).catch((error)=>{
            const response = {
                Data: undefined,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IPrayerSettings>;
        });

        return dbResponse;
    },
    updatePrayerSettings: (prayerSettings) => {
        const dbResponse: Promise<IApiResponse<IPrayerSettings>> = DexieDB.transaction('rw', DexieDB.prayerSettings, async()  => {
            return DexieDB.prayerSettings.put(prayerSettings).then((result)=>{
                const response = {...SuccessApiResponse, Data: prayerSettings};
                response.Message.UserMessage = 'SUCCESS: UPDATED PRAYER.';
                return response;
            });
        }).catch((error)=>{
            const response = {
                Data: prayerSettings,
                Success: false,
                Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
            }
            return response as IApiResponse<IPrayerSettings>;
        });

        return dbResponse;
    },
}

export default PrayerSettingsServiceWeb;